import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7058767b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=7058767b&prod&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=7058767b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7058767b",
  null
  
)

export default component.exports